import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { UtilsService } from '../../../shared/services/utils.service';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import {MatAccordion, MatExpansionModule } from '@angular/material/expansion';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-filters',
  standalone: true,
  imports:[CommonModule,MatCheckboxModule,MatRadioModule,MatExpansionModule,MatAccordion],
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.scss']
})
export class FiltersComponent implements OnInit {
  @Input('filterData') filterData: any;
  @Output() modelClose = new EventEmitter<{}>();
  environment: any = environment;
  filterValues: any = []
  sortBy: any;
 
  activeFilterObj: any;
  filterDataForMobile: any = [];
  constructor(public utils: UtilsService, private router: Router, private route: ActivatedRoute) {
  }

  ngOnInit(): void {
    if (this.utils.screenSizeObj.width < 768) {
      this.filterDataForMobile = JSON.parse(JSON.stringify(this.utils.filterData));
      this.setFilterValues(this.filterDataForMobile[0]);
    }
    else
      this.filterDataForMobile = []
  }



  setFilterValues(filterData: any) {
    this.activeFilterObj = filterData;
    this.filterValues = filterData.filterValues;
  }

  onFilterClick(filterOption: any, flag: boolean, isMobFilter: boolean) {
    filterOption['checked'] = flag;
    if (!isMobFilter) {
      this.utils.filterQueryObj = this.getQueryString();
      const urlTree = this.router.createUrlTree([], {
        queryParams: this.utils.filterQueryObj.queryObj,
        preserveFragment: false
      });
      this.router.navigateByUrl(urlTree);
    }
  }

  getQueryString() {
    let queryObj: any = {};
    let apiObj: any = [];
    this.utils.filterData.forEach((element: any) => {
      let value: any = '';
      element.filterValues.forEach((ele: any) => {
        if (ele.checked) {
          value += (value.length ? ',' : '') + ele.filterValue.toLowerCase().split(' ').join('-') + '_' + ele.filterValueId;
          let obj: any = {
            filterId: '',
            filterValue: ''
          };
          obj.filterId = element.filterID
          obj.filterValue = ele.filterValueId
          apiObj.push(obj);
        }
      });
      if (value.length) {
        queryObj[`${element.filterDisplayNames.toLowerCase().split(' ').join('-')}_${element.filterID}`] = value;
      }
    });
    return { queryObj: queryObj, apiObjArr: apiObj };
  }

  clearAll() {
    this.filterDataForMobile.forEach((element: any) => {
      element.filterValues.forEach((filterOption: any) => {
        if (filterOption.checked && !(element.filterID == 'sb' && filterOption.filterValueId == 1)) {
          filterOption.checked = false;
        }
      })
    });
    this.filterDataForMobile.forEach((element: any) => {
      element.filterValues.forEach((filterOption: any) => {
        if (element.filterID == 'sb' && filterOption.filterValueId == 1) {
          filterOption.checked = true;
        }
      })
    });
  }

  close() {
    this.modelClose.emit();
  }

  applyAll() {
    this.utils.filterData = JSON.parse(JSON.stringify(this.filterDataForMobile))
    this.utils.filterQueryObj = this.getQueryString();
    const urlTree = this.router.createUrlTree([], {
      queryParams: this.utils.filterQueryObj.queryObj,
      preserveFragment: false
    });
    this.router.navigateByUrl(urlTree);
    this.modelClose.emit();
  }

  checkExpansion(filterData: any) {
    let flag = false;
    if (filterData && filterData.filterValues && filterData.filterValues.length) {
      for (let filterValue of filterData.filterValues) {
        if (filterValue && filterValue.checked) {
          flag = true;
        }
      }
    }
    return flag;
  }

  radioButtonClicked(event: any, value: any, isMobile: boolean) {
    for (const x of value.filterValues) {
      if (x.filterValueId == event.value) {
        x['checked'] = true;
      }
      else {
        x['checked'] = false;
      }
    }
    if (!isMobile) {
      this.utils.filterQueryObj = this.getQueryString();
      const urlTree = this.router.createUrlTree([], {
        queryParams: this.utils.filterQueryObj.queryObj,
        preserveFragment: false
      });
      this.router.navigateByUrl(urlTree);
    }
  }
}

